// extracted by mini-css-extract-plugin
export default {"container":"KOAjHs","error":"vPIhff","center":"amZLob","content":"L7NFG4","close":"dHiBCK","mobile":"eTdDGV","hidden":"aeyjH1"};